import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { ToastType } from '../../enums/toast-type.enum';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
    constructor(private readonly toastService: ToastService) {}

    public downloadCSV(res: BlobPart, fileName: string): void {
        const blob = new Blob([res], { type: 'text/csv' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        globalThis.URL.revokeObjectURL(url);
        this.toastService.showToast(`${fileName} downloaded successfully.`, ToastType.Success);
    }
}
